import { useRef, useState, useEffect } from 'react';
import { Box, Grid2 } from '@mui/material';
import CustomDialog from '@ui-components/Dialog/CustomDialog';
import CustomDialogContent from '@ui-components/Dialog/CustomDialogContent';
import CustomButton from '@ui-components/Button/CustomButton';
import CustomDialogActions from '@ui-components/Dialog/CustomDialogActions';
import {
  useGetLanguage,
  useInviteInterpreter,
  useGetStatus,
  useSaveVoyceId,
  useUpdateInterpreterHistory,
} from '../../API/hooks/interpreterHook';
import { useMeetingLinkInviterpreter } from '../../shared/zoom/zoomSetup';
import CustomSelect from '@ui-components/Select/CustomSelect';
import type {
  LanguageLsitType,
  TransformedLanguage,
  VoyceResponseType,
  StatusType,
} from '../../API/services/interpreterService';
import type { ResponseData } from '@qler-view/shared_lib/src/shared/zoom';
import CustomTypography from '@ui-components/Typography/CustomTypography';
import InterpreterIcon from '@assets/images/Interpreter.svg';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { VOYCE_STATUS } from '../../shared/lib/utils/voyceEnum';
import CustomSnackbar from '@ui-components/Snackbar/CustomSnackbar';

interface InterpreterProps {
  ConsultId: number;
  callstatus: string;
}

const Interpreter = (props: Readonly<InterpreterProps>) => {
  const MessageRef = useRef('');
  const ConsultId = props.ConsultId;
  const Languages = useRef<TransformedLanguage[]>([]);

  const [open, setOpen] = useState<boolean>(false);
  const [interpreterPopupOpen, setInterpreterPopupOpen] =
    useState<boolean>(false);

  const [openToast, setOpenToast] = useState(false);
  const [SeletedLanguageId, setSeletedLanguageId] = useState<number | string>(
    0
  );
  const { mutate: mutateLanguage } = useGetLanguage();
  const { mutate: mutateInviteInterpreter } = useInviteInterpreter();
  const { mutate: mutateStatus } = useGetStatus();
  const { mutate: mutateMeetingLink } = useMeetingLinkInviterpreter();
  const [autoDuration, setAutoDuration] = useState<boolean>(true);
  const { mutate: mutateSaveVoyceId } = useSaveVoyceId();
  const initialLanguageValue = {
    language: '',
  };
  const userId = Number.parseInt(localStorage.getItem('userId') ?? '0');

  const { mutate: updateInterpreterHistory } =
    useUpdateInterpreterHistory(userId);

  const validationLanguageSchema = Yup.object().shape({
    language: Yup.string().required('Language is required'),
  });
  useEffect(() => {
    if (props.callstatus === 'call completed') {
      localStorage.removeItem(`voyceID-${ConsultId}`);
    }
  }, [props.callstatus]);
  useEffect(() => {
    const timeout = setInterval(() => {
      const voyceId = localStorage.getItem(`voyceID-${ConsultId}`);
      setAutoDuration(false);
      if (voyceId !== null) {
        mutateStatus(voyceId, {
          onSuccess: (data: StatusType) => {
            if (data?.StatusCodeId === VOYCE_STATUS.NEW) {
              MessageRef.current = `Interpreter invited successfully.\n ${data.EstimationTimeString}`;
              setOpenToast(true);
            } else if (
              data?.StatusCodeId === VOYCE_STATUS.NO_INTERPRETER_AVAILABLE
            ) {
              MessageRef.current =
                MessageRef.current = `No Interpreter Available.\n ${data.EstimationTimeString}`;

              setOpenToast(true);
              updateInterpreterHistory({
                consultId: ConsultId,
                language: initialLanguageValue.language,
                message: data.EstimationTimeString,
                actionFlag: true,
              });
            } else if (data?.StatusCodeId === VOYCE_STATUS.IN_SERVICE) {
              MessageRef.current = `An interpreter has joined your Zoom meeting.`;
              setOpenToast(true);
              updateInterpreterHistory({
                consultId: ConsultId,
                language: initialLanguageValue.language,
                message: data.EstimationTimeString,
                actionFlag: true,
              });
            } else if (data?.StatusCodeId === VOYCE_STATUS.CANCELLED) {
              MessageRef.current = `Interpreter Cancelled the service`;
              setOpenToast(true);
              updateInterpreterHistory({
                consultId: ConsultId,
                language: initialLanguageValue.language,
                message: data.EstimationTimeString,
                actionFlag: true,
              });
              localStorage.removeItem(`voyceID-${ConsultId}`);
            } else if (
              data?.StatusCodeId === VOYCE_STATUS.INTERPRETER_ACCEPTED
            ) {
              MessageRef.current = `Interpreter Accepted the service`;
              setOpenToast(true);
            } else if (data?.StatusCodeId === VOYCE_STATUS.SERVICED) {
              MessageRef.current = `Interpreter Serviced the service`;
              setOpenToast(true);
              localStorage.removeItem(`voyceID-${ConsultId}`);
              setOpenToast(false);
            }
          },
        });
      }
    }, 5000);

    return () => clearInterval(timeout);
  }, [localStorage.getItem(`voyceID-${ConsultId}`)]);

  const handleOpen = () => {
    if (localStorage.getItem(`voyceID-${ConsultId}`)) {
      setInterpreterPopupOpen(true);
    } else {
      mutateLanguage(undefined, {
        onSuccess: (data: LanguageLsitType) => {
          if (
            Array.isArray(data.LanguageList) &&
            data.LanguageList.length > 0
          ) {
            const transformedLanguages = data.LanguageList.map((language) => ({
              id: language.LanguageId,
              name: language.LanguageName,
            }));

            Languages.current = transformedLanguages;

            setOpen(true);
          } else {
            console.log('Access Denied');
          }
        },
        onError: (error) => {
          console.log('error', error);
        },
      });
    }
  };
  const handleClose_SnackBar = () => {
    setOpenToast(false);
  };

  const ifApiTrue = (data: VoyceResponseType) => {
    if (data?.Successful === true) {
      setSeletedLanguageId(0);
      MessageRef.current = 'Interpreter invited successfully';
      setOpenToast(true);
    }
    localStorage.setItem(`voyceID-${ConsultId}`, data.RequestId.toString());
    setOpen(false);
    setTimeout(() => {
      MessageRef.current = '';
      setOpenToast(false);
    }, 5000);
  };
  const ifURLExists = (url: string) => {
    mutateInviteInterpreter(
      {
        LanguageId: SeletedLanguageId,
        MeetingId: 0,
        URL: url,
      },
      {
        onSuccess: (data: VoyceResponseType) => {
          ifApiTrue(data);
          mutateSaveVoyceId({
            voyceId: data.RequestId,
            caseId: ConsultId,
            userId: Number.parseInt(localStorage.getItem('userId') ?? '0'),
          });
        },
      }
    );
  };
  const handleSubmit = async () => {
    let url;
    mutateMeetingLink(
      {
        meetingId: localStorage.getItem(`meetingUrl-${ConsultId}`),
        name: 'Interpreter',
      },
      {
        onSuccess: (data: ResponseData) => {
          url = data?.attendees?.[0].join_url;
          if (url !== undefined) {
            ifURLExists(url);
          }
        },
      }
    );
  };

  return (
    <>
      {openToast && (
        <CustomSnackbar
          className="interpreter-snackbar"
          id="interpreter-toast"
          successOrError={'success'}
          open={openToast}
          handleClose={handleClose_SnackBar}
          toastrMessage={MessageRef.current}
          autoHide={autoDuration}
        />
      )}
      <Box>
        <CustomDialog
          id="interpreterWarning"
          open={interpreterPopupOpen}
          onClose={() => {
            setInterpreterPopupOpen(false);
          }}
          disableEscapeKeyDown={true}
        >
          <CustomDialogContent className="dialog-width">
            <Box className="pb-12 flex-justify-space-between">
              <InterpreterIcon />
            </Box>
            <Box className="pb-4">
              <CustomTypography id="interpreter-title" variant="subtitle1">
                Invite Interpreter
              </CustomTypography>
            </Box>
            <Box>
              <CustomTypography id="interpreter-title-popup" variant="body3">
                An interpreter request is pending with Voyce. Do you want to
                submit a request again?
              </CustomTypography>
            </Box>
          </CustomDialogContent>

          <CustomDialogActions>
            <Grid2 container>
              <Grid2 className="mr-8">
                <CustomButton
                  id="popupIntrerpreterCancel"
                  color="error"
                  variant="outlined"
                  onClick={() => {
                    setInterpreterPopupOpen(false);
                  }}
                >
                  Cancel
                </CustomButton>
              </Grid2>
              <Grid2>
                <CustomButton
                  id="submit-againInterpreter"
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    localStorage.removeItem(`voyceID-${ConsultId}`);
                    setInterpreterPopupOpen(false);
                    handleOpen();
                  }}
                >
                  Submit Again
                </CustomButton>
              </Grid2>
            </Grid2>
          </CustomDialogActions>
        </CustomDialog>
      </Box>
      <CustomButton
        id="btnInterpreter"
        variant="outlined"
        size="small"
        onClick={() => handleOpen()}
      >
        Invite Interpreter
      </CustomButton>
      <Formik
        initialValues={initialLanguageValue}
        validateOnMount={false}
        validationSchema={validationLanguageSchema}
        onSubmit={() => {
          handleSubmit();
        }}
      >
        {({
          setFieldValue,
          values,
          handleSubmit,
          resetForm,
          errors,
          touched,
        }) => (
          <Box>
            <CustomDialog
              id="dialogWarningInterpreter"
              open={open}
              onClose={() => {
                setOpen(false);
                resetForm();
              }}
              disableEscapeKeyDown={true}
            >
              <CustomDialogContent className="dialog-width">
                <Box className="pb-12 flex-justify-space-between">
                  <InterpreterIcon />
                </Box>
                <Box className="pb-4">
                  <CustomTypography id="invite-title-popup" variant="subtitle1">
                    Invite Interpreter
                  </CustomTypography>
                </Box>
                <Box>
                  <CustomTypography
                    id="interpreter-title-popup"
                    variant="body3"
                  >
                    Please choose the required language to assign an
                    interpreter.
                  </CustomTypography>
                </Box>

                <Box className="mt-16">
                  <CustomSelect
                    id="selectInterpreter"
                    placeholder="Select Language"
                    options={Languages.current ?? []}
                    selectedValue={values.language}
                    onChange={(e: number | string) => {
                      setSeletedLanguageId(e);

                      setFieldValue('language', e);
                    }}
                    size="small"
                    displayEmpty={true}
                    fullWidth
                  />

                  {errors?.language && touched?.language && (
                    <CustomTypography
                      id="validate-Interpreterlanguage"
                      color="error"
                      variant="body3"
                      className="pt-8"
                    >
                      {errors.language}
                    </CustomTypography>
                  )}
                </Box>
              </CustomDialogContent>

              <CustomDialogActions>
                <Grid2 container>
                  <Grid2 className="mr-8">
                    <CustomButton
                      id="interpreter-close"
                      color="error"
                      variant="outlined"
                      onClick={() => {
                        setOpen(false);
                        resetForm();
                      }}
                    >
                      Close
                    </CustomButton>
                  </Grid2>
                  <Grid2>
                    <CustomButton
                      id="interpreter-submit"
                      color="primary"
                      variant="contained"
                      disabled={SeletedLanguageId === 0}
                      onClick={() => {
                        handleSubmit();
                        resetForm();
                      }}
                    >
                      Submit
                    </CustomButton>
                  </Grid2>
                </Grid2>
              </CustomDialogActions>
            </CustomDialog>
          </Box>
        )}
      </Formik>
    </>
  );
};
export default Interpreter;
